import { getAppConfig } from '@client/core/config/get-app-config';
import { Workspace } from '@client/features/workspace/models/workspace';

export function getCurrentWorkspace(): Workspace {
  const { workspace } = getAppConfig();

  return workspace;
}
